import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const paymentOptionsPopoverContent = style({
  padding: space.s32,
  width: 570,
});

export const paymentOptionsForm = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
});

export const paymentOptionsTitle = style([
  typography.titleSm,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
    color: themeVars.container.foreground.secondary,
  },
]);

export const paymentOptionDescription = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const paymentOptionsTabItem = style({
  flexGrow: 1,
  justifyContent: 'center',
});

export const paymentOptionsTabContent = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  alignItems: 'stretch',
});

export const paymentOptionsSubmit = style({
  marginTop: space.s8,
});
export const paymentOptionsTabContentFooter = style([
  typography['bodyMd'],
  {
    color: themeVars.container.foreground.tertiary,
    textAlign: 'center',
  },
]);

export const paymentOptionsAlertContent = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s8,
});

export const paymentOptionsAlertTitle = style([typography['titleSm']]);

export const paymentOptionsAlertDescription = style([
  typography['bodyMd'],
  {
    color: themeVars.container.foreground.tertiary,
  },
]);

export const paymentOptionSelectTriggerContainer = style(
  responsiveStyle({
    mobile: {
      gridColumn: '1 / 3',
      marginLeft: 'auto',
    },
    tablet: {
      gridColumn: '3',
      minWidth: 130,
      marginLeft: 0,
    },
  }),
);

export const paymentOptionSelectTrigger = style([
  {
    width: '100%',
  },
]);

export const paymentOptionCallout = style([
  {
    selectors: {
      ['&:is(&)']: {
        alignItems: 'start',
      },
    },
  },
  responsiveStyle({
    mobile: {
      gridTemplateColumns: `auto 1fr !important`,
      gridTemplateAreas: `
        "icon body"
        "actions actions"
      !important`,
    },
    tablet: {
      gridTemplateColumns: `auto 1fr auto !important`,
      gridTemplateAreas: `
        "icon body actions"
      !important`,
    },
  }),
]);

export const paymentOptionDiscountBadge = style([
  typography.labelSm,
  {
    color: themeVars.container.foreground.critical,
    marginLeft: space.s8,
  },
]);

export const paymentOptionsDrawerContent = style({
  padding: `0 ${space.s32}px ${space.s48}px ${space.s32}px`,
  minHeight: 450,
});

export const paymentOptionsDrawerTitle = style({
  marginBottom: space.s20,
});
